// src/components/SizeSelect.jsx
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useData } from "../hooks/useData";

export default function SizeSelect({ lineId }) {
  const { lines, updateLine, selectedProduct } = useData();
  const line = lines.find((l) => l.id === lineId);
  if (!line || !selectedProduct) return null;

  const sizes = selectedProduct.sizes || [];

  const handleChange = (e) => {
    const sizeCode = e.target.value;
    const sizeObj = sizes.find((s) => s.code === sizeCode);
    updateLine(lineId, {
      size: sizeCode,
      sizeName: sizeObj?.name || "Unknown Size",
    });
  };

  return (
    <FormControl size="small" sx={{ minWidth: 100 }}>
      <InputLabel>Size</InputLabel>
      <Select value={line.size} label="Size" onChange={handleChange}>
        {sizes.map((s) => (
          <MenuItem key={s.code} value={s.code}>
            {s.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
